export default __webpack_public_path__ + "img/text-widget-empty.f9b500d2.svg";